import React, { Component } from 'react'
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { UserActions } from '../../actions';
import TitleBar from '../../components/TitleBar';
import SubnavBar from '../../components/SubnavBar';
import UserForm from '../../components/Users/Edit';

class EditUser extends Component {
 constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);

    this.state = {
      error: false
    }
  }

  gotoUsers = () => {
    browserHistory.push('/admin/users');
  }
  
  saveUser = (values) => {
    const { user } = this.props;
    let shipperId;
    let carrierId;
    let isShipper = values.isShipper;
    if (_.get(user, 'profile.roles') === 'shipper-admin') {
      shipperId = _.get(user, 'profile.shipperId');
      carrierId = _.get(user, 'profile.carrierId');
      isShipper = true;
    } else if (_.get(user, 'profile.roles') === 'carrier-admin') {
      shipperId = values.shipperId;
      carrierId = _.get(user, 'profile.carrierId');
    } else {
      shipperId = values.shipperId;
      shipperId = values.carrierId;
    }

    const newUser = {
      name: values.name,
      username: values.username,
      password: values.password,
      roles: values.roles,
      carrierId,
      shipperId,
      isShipper: isShipper || false,
    };

    this.props.dispatch(UserActions.createUser(newUser)).then((response) => {
      this.props.dispatch(UserActions.getUsers()).then(() => {
        browserHistory.push('/admin/users');
      });
    }).catch((e) => {
      this.setState({
        error: true
      })
    });
  }

  handleClose = () => {
    this.setState({
      error: false
    });
  }

  render() {
    const { user } = this.props;
    const actions = [
      <FlatButton label="Ok" primary onTouchTap={this.handleClose} />
    ];
    return (
      <div className="row">
        <div className="col s12 align-center">
          <SubnavBar back={this.gotoUsers} />
          <TitleBar title="Create User" />
          <div className="row">
            <div className="col s12">
              <UserForm onSubmit={this.saveUser} companies={this.props.companies} user={user} />
              <Dialog
                actions={actions}
                modal={false}
                open={this.state.error}
                onRequestClose={this.handleClose}
              >
                There was an error saving the user.
              </Dialog>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  const { user, companies } = state;
  return {
    user,
    companies
  }
}

export default connect(mapStateToProps)(EditUser);


// WEBPACK FOOTER //
// ./src/containers/Users/Edit.js